module.exports = __webpack_public_path__ + "static/media/schedule.6cb63024.svg";